/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if (this.parent) {
						this.parent.classList.add('product-recommendations--full');

						if (document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}

					// Inicializa lógica de bundle (checkboxes, totais e botão "comprar todos")
					this.initBundle();

				}

				this.classList.add('product-recommendations--loaded');

			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		if (this.dataset.useMetafieldRecommendations === 'true') {
			this.initBundle();
			this.classList.add('product-recommendations--loaded');
			return;
		}
		this.fetchProducts();
	}
	initBundle() {
		const bundleContainer = this.querySelector('[data-bundle-container]');
		if (!bundleContainer) {
			return;
		}

		this.bundleItems = Array.from(bundleContainer.querySelectorAll('.bundle-item'));
		this.bundleCheckboxes = Array.from(bundleContainer.querySelectorAll('.bundle-item-checkbox'));
		this.bundleSummary = bundleContainer.querySelector('[data-bundle-summary]');
		this.bundlePriceOldEl = bundleContainer.querySelector('[data-bundle-price-old]');
		this.bundlePriceNewEl = bundleContainer.querySelector('[data-bundle-price-new]');
		this.bundleAddButton = bundleContainer.querySelector('[data-bundle-add]');

		if (!this.bundleItems.length || !this.bundleSummary || !this.bundleAddButton) {
			return;
		}

		// Eventos de alteração de seleção
		this.bundleCheckboxes.forEach((checkbox) => {
			checkbox.addEventListener('change', () => {
				this.updateCardItem(checkbox);
				this.updateBundleTotals();
			});
		});

		// Clique no botão "adicionar selecionados"
		this.bundleAddButton.addEventListener('click', () => {
			this.addSelectedToCart();
		});

		// Troca de variante no card (swatch) pode mudar disponibilidade e preço do item
		bundleContainer.addEventListener('bundle-item:change', (event) => {
			const item = event.target.closest('.bundle-item');
			if (!item) return;
			this.syncItemAvailability(item);
			this.updateBundleTotals();
		});

		// Itens esgotados começam desmarcados
		this.bundleItems.forEach((item) => this.syncItemAvailability(item));

		// Calcula totais iniciais
		this.updateBundleTotals();
	}

	syncItemAvailability(item) {
		const checkbox = item.querySelector('.bundle-item-checkbox');
		if (!checkbox) return;

		const soldOut = item.dataset.available === 'false';

		item.classList.toggle('sold-out', soldOut);
		checkbox.disabled = soldOut || checkbox.hasAttribute('data-locked');

		if (soldOut) {
			checkbox.checked = false;
		}

		this.updateCardItem(checkbox);
	}

	updateCardItem(checkbox) {
		this.cardItem = checkbox.closest('.bundle-item');
		this.cardItem.classList.toggle('selected', checkbox.checked);
		this.updateSelectedImagesStrip(checkbox);
	}

	updateSelectedImagesStrip(checkbox) {
		const strip = this.querySelector('[data-selected-images]');
		if (!strip) return;
		const index = this.bundleCheckboxes.indexOf(checkbox);
		if (index < 0) return;
		const slot = strip.querySelector(`.product-recommendations__selected-image-item[data-bundle-index="${index}"]`);
		if (slot) {
			slot.classList.toggle('is-visible', checkbox.checked);
		}
	}

	updateBundleTotals() {
		if (!this.bundleItems || !this.bundleItems.length) {
			return;
		}

		let totalPrice = 0;
		let totalCompareAt = 0;
		let selectedCount = 0;

		this.bundleItems.forEach((item, index) => {
			const checkbox = this.bundleCheckboxes[index];
			if (!checkbox || !checkbox.checked) {
				return;
			}

			const price = parseInt(item.dataset.price, 10) || 0;
			const compareAtPrice = parseInt(item.dataset.compareAtPrice, 10);

			totalPrice += price;

			if (!isNaN(compareAtPrice) && compareAtPrice > 0) {
				// Se tiver compare_at_price válido, usamos ele como "preço antigo" desse item.
				totalCompareAt += compareAtPrice;
			} else {
				// Caso contrário, o preço antigo é o próprio preço atual.
				totalCompareAt += price;
			}

			selectedCount += 1;
		});

		// Habilita/desabilita botão
		this.bundleAddButton.disabled = selectedCount === 0;

		if (selectedCount === 0) {
			if (this.bundlePriceOldEl) this.bundlePriceOldEl.textContent = '';
			if (this.bundlePriceNewEl) this.bundlePriceNewEl.textContent = '';
			return;
		}

		const hasDiscount = totalCompareAt > totalPrice;

		if (this.bundlePriceOldEl) {
			this.bundlePriceOldEl.textContent = hasDiscount ? this.formatMoney(totalCompareAt) : '';
			this.bundlePriceOldEl.style.display = hasDiscount ? '' : 'none';
		}

		if (this.bundlePriceNewEl) {
			this.bundlePriceNewEl.textContent = this.formatMoney(totalPrice);
		}
	}
	getSelectedItems() {
		const items = [];

		if (!this.bundleItems || !this.bundleItems.length) {
			return items;
		}

		this.bundleItems.forEach((item, index) => {
			const checkbox = this.bundleCheckboxes[index];
			if (!checkbox || !checkbox.checked) {
				return;
			}

			const variantId = item.dataset.variantId;
			if (!variantId) {
				return;
			}

			items.push({
				id: parseInt(variantId, 10),
				quantity: 1
			});
		});

		return items;
	}
	addSelectedToCart() {
		this.bundleAddButton.classList.add('loading');

		const items = this.getSelectedItems();
		if (!items.length) {
			this.bundleAddButton.classList.remove('loading');
			return;
		}

		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			},
			body: JSON.stringify({ items })
		})
			.then(response => response.json())
			.then(() => {
				dispatchCustomEvent('cart:refresh');

				const cartDrawer = document.getElementById('Cart-Drawer');
				if (cartDrawer) {
					document.body.classList.add('open-cc');
					document.body.classList.add('open-cart');
					cartDrawer.classList.add('active');
					cartDrawer.focus();
					cartDrawer.querySelector('.product-recommendations--full')?.classList.add('active');
					dispatchCustomEvent('cart-drawer:open');
				}

				dispatchCustomEvent('cart:item-added', {
					product: items[0]
				});
			})
			.catch((e) => {
				console.error(e);
			})
			.finally(() => {
				this.bundleAddButton.classList.remove('loading');
			});
	}
	formatMoney(cents) {
		if (cents == null || isNaN(cents)) return '';
		const value = cents / 100;
		const currencyCode = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active)
			? Shopify.currency.active
			: 'USD';
		const locale = (typeof Shopify !== 'undefined' && Shopify.locale)
			? Shopify.locale
			: 'en';
		try {
			return new Intl.NumberFormat(locale, {
				style: 'currency',
				currency: currencyCode,
				minimumFractionDigits: 0,
				maximumFractionDigits: 0
			}).format(value);
		} catch (e) {
			return '$' + Math.round(value);
		}
	}
}

customElements.define('product-recommendations', ProductRecommendations);
